import { withLDProvider, withLDConsumer } from 'launchdarkly-react-client-sdk';
import globalConfig from 'react-global-configuration';
import getOrgAlias from '@shootsta/get-alias';
import { credentials } from '@shootsta/client-auth';

const withFlagsProvider = (Component) => {
  const { user } = credentials.get() || {};
  const orgAlias = getOrgAlias();
  const defaultClientSideID = '6260be9f41b3481588213f7e';
  let clientSideID = defaultClientSideID;
  try {
    clientSideID = globalConfig.get('featureFlagServiceClientId');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Error in reading featureFlagServiceClientId');
  }

  return withLDProvider({
    clientSideID,
    context: {
      kind: 'user',
      key: user ? user.email : 'unknown-user-id',
      email: user ? user.email : 'unknown@user.com',
      orgAlias
    }
  })(Component);
};

const withFlagsConsumer = (Component) => withLDConsumer()(Component);

export { withFlagsProvider, withFlagsConsumer };